import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { formatDate, formatNumber } from '../utils/sessionDetailHelpers'

// Shared table for the Composition/Circumference/Vitals sections of the measurements tab.
// `renderInput`/`renderActionCell` stay as callbacks owned by the parent (they close over
// editing/draft state that isn't worth lifting into this component for this pass).
const MeasurementsTable = ({
  type,
  title,
  unitNote,
  columns,
  rows,
  totals,
  editingRow,
  actionLoading,
  measurementsLoading,
  onAddRow,
  renderInput,
  renderActionCell,
  getRowKey,
}) => (
  <Card className="border-0 shadow-sm ring-1 ring-fitness-primary/10">
    <CardHeader className="pb-2 flex flex-row items-center gap-3 flex-wrap space-y-0 justify-start">
      <CardTitle className="text-base font-semibold text-slate-900">{title}</CardTitle>
      <button
        type="button"
        onClick={onAddRow}
        disabled={actionLoading || measurementsLoading}
        className="inline-flex items-center gap-2 rounded-md border border-fitness-primary/30 bg-white px-3 py-1.5 text-sm font-semibold text-fitness-primary shadow-sm transition hover:bg-fitness-primary/10 disabled:cursor-not-allowed disabled:opacity-70"
      >
        Add row
      </button>
    </CardHeader>
    <CardContent className="pt-0">
      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-background text-slate-500 text-xs">
            <tr>
              <th className="px-3 py-3 font-medium">Date</th>
              {columns.map((column) => (
                <th key={column.key} className="px-3 py-3 font-medium">
                  {column.label}
                </th>
              ))}
              <th className="px-3 py-3 font-medium text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => {
              const key = getRowKey(row, type, index)
              const isEditing = editingRow?.type === type && editingRow?.id === key
              return (
                <tr key={key} className="border-t border-slate-100">
                  <td className="px-3 py-3 text-slate-800">
                    {isEditing ? renderInput(type, key, 'measured_at', row.measured_at, true) : formatDate(row.measured_at)}
                  </td>
                  {columns.map((column) => (
                    <td key={column.key} className="px-3 py-3 text-slate-800">
                      {isEditing ? renderInput(type, key, column.key, row[column.key]) : formatNumber(row[column.key])}
                    </td>
                  ))}
                  {renderActionCell(type, key, isEditing)}
                </tr>
              )
            })}
            <tr className="border-t border-fitness-primary/20 bg-fitness-primary/5 font-semibold text-slate-900">
              <td className="px-3 py-3">Totals</td>
              {columns.map((column) => (
                <td key={column.key} className="px-3 py-3">
                  {formatNumber(totals[column.totalsKey ?? column.key])}
                </td>
              ))}
              <td className="px-3 py-3" />
            </tr>
          </tbody>
        </table>
      </div>
      {unitNote && <p className="mt-3 text-xs text-slate-500">{unitNote}</p>}
    </CardContent>
  </Card>
)

export default MeasurementsTable
